// src/auth/ProtectedRoute.js
import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { isAdminOrganizationView } from "../utils/adminOrganizationView";

export default function ProtectedRoute() {
  const [loading, setLoading] = useState(true);
  const [authed, setAuthed] = useState(false);
  const [isFamily, setIsFamily] = useState(false);
  const [canAccessAdmin, setCanAccessAdmin] = useState(false);
  const location = useLocation();

  useEffect(() => {
    let alive = true;
    const ctrl = new AbortController();

    (async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/me`, {
          credentials: "include",
          signal: ctrl.signal,
        });
        if (!alive) return;
        if (!res.ok) {
          setAuthed(false);
          setIsFamily(false);
          return;
        }
        const data = await res.json();
        setAuthed(true);
        setIsFamily(data?.role === "family_member");
        setCanAccessAdmin(data?.can_access_admin === true);
      } catch {
        if (!alive) return;
        setAuthed(false);
        setIsFamily(false);
      } finally {
        if (!alive) return;
        setLoading(false);
      }
    })();

    return () => {
      alive = false;
      ctrl.abort();
    };
  }, []);

  if (loading) {
    return <div className="p-6 text-sm text-gray-500">Checking session…</div>;
  }
  if (!authed) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  if (isFamily) {
    return <Navigate to="/family" replace />;
  }
  if (canAccessAdmin && !isAdminOrganizationView() && !location.pathname.startsWith("/admin")) {
    return <Navigate to="/admin" replace />;
  }
  if (!canAccessAdmin && location.pathname.startsWith("/admin")) {
    return <Navigate to="/übersicht" replace />;
  }
  return <Outlet />;
}
